<script setup lang="ts">
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { useI18n } from 'vue-i18n';

import useTenant from '@/shared/composables/useTenant';

// Init
const { t } = useI18n();
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();

const openLink = (appPlatform: string) => {
	if (appPlatform == 'android') {
		Browser.open({ url: tenantConfig.value!.native_url_android });
	}

	if (appPlatform == 'ios') {
		Browser.open({ url: tenantConfig.value!.native_url_apple });
	}
};
</script>

<template>
	<div v-if="!Capacitor.isNativePlatform()" class="flex flex-col items-center justify-center mb-2 py-4 rounded-md">
		<div class="mb-2 font-sourcesanspro-regular text-base2 text-white">{{ t('components.install_app.get_the_app') }}</div>
		<div class="flex items-center justify-evenly w-full">
			<img class="w-[140px]" role="button" src="@/statics/png/stores/download_on_the_app_store.png" @click="openLink('ios')" />
			<img class="w-[140px]" role="button" src="@/statics/png/stores/get_it_on_google_play.png" @click="openLink('android')" />
		</div>
	</div>
</template>

<style scoped></style>
